function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var KeyTemplate = require('./keyentry.template');
var PhraseTemplate = require('./phraseentry.template');
var PasswordTemplate = require('./passwordentry.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoRecover = /*#__PURE__*/function () {
  function SaitoRecover(app, mod) {
    _classCallCheck(this, SaitoRecover);
    this.app = app;
    this.mod = mod;
    this.modal_overlay = new SaitoOverlay(this.app, this.mod);
  }
  return _createClass(SaitoRecover, [{
    key: "render",
    value: function render() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'key';
      if (mode == 'key') {
        this.modal_overlay.show(KeyTemplate());
      } else {
        this.modal_overlay.show(PhraseTemplate());
      }
      document.querySelector('.saito-overlay-form-input').focus();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      if (document.getElementById('private-key-submit')) {
        document.getElementById('private-key-submit').onclick = function (e) {
          var privatekey = document.getElementById('private-key-input').value;
          _this.loadPrivateKey(privatekey);
        };
      }
      if (document.getElementById('seed-phrase-submit')) {
        document.getElementById('seed-phrase-submit').onclick = function (e) {
          var seedPhrase = document.getElementById('seed-phrase-input').value;
          var privatekey = _this.app.crypto.getPrivateKeyFromSeed(seedPhrase);
          _this.loadPrivateKey(privatekey);
        };
      }
      if (document.getElementById('input-seed-phrase')) {
        document.getElementById('input-seed-phrase').onclick = function () {
          _this.render('phrase');
        };
      }
      if (document.getElementById('input-private-key')) {
        document.getElementById('input-private-key').onclick = function () {
          _this.render('key');
        };
      }
    }
  }, {
    key: "loadFile",
    value: function loadFile() {
      if (!document.getElementById('file-input')) {
        this.app.browser.addElementToDom("<input id=\"file-input\" class=\"file-input\" type=\"file\" accept=\".json, .aes\" style=\"display:none;\" />");
      }
      var this_self = this;
      document.getElementById('file-input').addEventListener('change', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
          var file, wallet_reader;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                file = e.target.files[0];
                wallet_reader = new FileReader();
                wallet_reader.readAsBinaryString(file);
                wallet_reader.onloadend = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var wallet;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        wallet = wallet_reader.result.toString();
                        if (!this_self.app.crypto.isAesEncrypted(wallet)) {
                          _context.n = 1;
                          break;
                        }
                        this_self.modal_overlay.show(PasswordTemplate());
                        document.querySelector('#wallet-decryption-submit').onclick = function (e) {
                          var email = document.querySelector('.saito-overlay-form-email').value;
                          var password = document.querySelector('.saito-overlay-form-password').value;
                          var hash1 = 'WHENINDISGRACEWITHFORTUNEANDMENSEYESIALLALONEBEWEEPMYOUTCASTSTATE';
                          var hash2 = 'ANDTROUBLEDEAFHEAVENWITHMYBOOTLESSCRIESANDLOOKUPONMYSELFANDCURSEMYFATE';
                          var decryption_secret = this_self.app.crypto.hash(this_self.app.crypto.hash(email + password) + hash1);
                          try {
                            var decrypted_wallet = this_self.app.crypto.aesDecrypt(wallet, decryption_secret);
                            this_self.installWallet(decrypted_wallet);
                          } catch (err) {
                            salert('Invalid email and/or password');
                          }
                        };
                        _context.n = 2;
                        break;
                      case 1:
                        _context.n = 2;
                        return this_self.installWallet(wallet);
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), {
        once: true
      });
      document.getElementById('file-input').click();
    }
  }, {
    key: "installWallet",
    value: function () {
      var _installWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(wallet) {
        var result, c, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return this.app.wallet.onUpgrade('import', '', wallet);
            case 1:
              result = _context3.v;
              if (!(result === true)) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return sconfirm('Success! Confirm to reload');
            case 2:
              c = _context3.v;
              if (c) {
                reloadWindow(300);
              }
              _context3.n = 4;
              break;
            case 3:
              salert('Error installing wallet');
              console.error(result);
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              console.err('Install Wallet ERROR: ', _t);
              salert('Unable to install wallet');
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function installWallet(_x2) {
        return _installWallet.apply(this, arguments);
      }
      return installWallet;
    }()
  }, {
    key: "loadPrivateKey",
    value: function () {
      var _loadPrivateKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(privatekey) {
        var result, c, err, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!privatekey) {
                _context4.n = 7;
                break;
              }
              _context4.p = 1;
              _context4.n = 2;
              return this.app.wallet.onUpgrade('import', privatekey);
            case 2:
              result = _context4.v;
              if (!(result === true)) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return sconfirm('Success! Confirm to reload');
            case 3:
              c = _context4.v;
              if (c) {
                reloadWindow(300);
              }
              _context4.n = 5;
              break;
            case 4:
              err = result;
              salert('Something went wrong: ' + err.name);
            case 5:
              _context4.n = 7;
              break;
            case 6:
              _context4.p = 6;
              _t2 = _context4.v;
              salert('Restore Private Key ERROR: <br> ' + _t2);
              console.error('Restore Private Key ERROR: ' + _t2);
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 6]]);
      }));
      function loadPrivateKey(_x3) {
        return _loadPrivateKey.apply(this, arguments);
      }
      return loadPrivateKey;
    }()
  }]);
}();
module.exports = SaitoRecover;